import linkRuleHover from '../../../../common/algorithms/link-rule-hover';

const primary = (params) => linkRuleHover(params);

export default primary;
